import { Symbol } from './context'

const { isConcatSpreadable: contextSymbolIsConcatSpreadable } = Symbol
export default contextSymbolIsConcatSpreadable
